<seds-loaders-core [mode]="mode" [type]="type" [current]="current" [total]="total"></seds-loaders-core>
